import { createGateways } from '@p1plug/platform';

export const gateways = createGateways();
export const tenant = gateways.tenant;
